<h1 mat-dialog-title><b>{{'partner-manager.create-software-dialog.title'|translate}}</b></h1>
<div mat-dialog-content style="height: 100%">
  <div mat-dialog-actions>
    <!-- Name component -->
    <mat-form-field style="width: 200px">
      <input matInput #name placeholder="{{'partner-manager.create-software-dialog.software-name'|translate}}" [value]=""
             (change)="nameChanges(name)">
    </mat-form-field>
    <!-- Version component -->
    <div>
      <mat-form-field style="width: 300px; margin-right: 50px">
        <mat-chip-list #chipList aria-label="Versions selection">
          <mat-chip *ngFor="let version of getVersionsArray()"
                    [removable]="true" (removed)="removeVersion(version)">
            {{version}}
            <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
          </mat-chip>
          <input placeholder="{{'partner-manager.create-software-dialog.active-versions'|translate}}"
                 [matChipInputFor]="chipList"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 [matChipInputAddOnBlur]="true"
                 (matChipInputTokenEnd)="addVersion($event)">
        </mat-chip-list>
      </mat-form-field>
      <!-- Price component -->
      <mat-form-field style="margin-right: 10px">
        <input matInput #price placeholder="{{'partner-manager.create-software-dialog.price'|translate}}" [value]=""
               (change)="priceChanges(price)">
      </mat-form-field>
      <p style="display: inline;" matLine>&euro;/{{'partner-manager.create-software-dialog.month'|translate}}</p>
    </div>
    <!-- Description -->
    <mat-form-field style="width: 300px; margin-right: 50px">
            <textarea matInput #description placeholder="{{'partner-manager.create-software-dialog.description'|translate}}" [value]=""
                      (input)="descrChanges(description)"></textarea>
    </mat-form-field>
    <!-- Short Description -->
    <mat-form-field  style="width: 300px; margin-right: 20px">
      <input matInput #short_description placeholder="{{'partner-manager.create-software-dialog.short-description'|translate}}"
             [value]=""
             (input)="shDescrChanges(short_description)">
    </mat-form-field>
    <div style="background: whitesmoke; padding: 10px">
      <mat-form-field  style="width: 300px; margin-right: 20px">
        <mat-label>Tipo proprietà</mat-label>
        <mat-select #propType required [value]="propOption">
          <mat-option *ngFor="let option of options" [value]="option">
            {{option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field  style="width: 250px; margin-right: 50px">
        <input #propName matInput [value]="" placeholder="{{'partner-manager.create-software-dialog.prop-name'|translate}}">
      </mat-form-field>
      <mat-form-field  style="width: 300px; margin-right: 20px">
        <input #propValue matInput [value]="" placeholder="{{'partner-manager.create-software-dialog.prop-value'|translate}}">
      </mat-form-field>
      <button mat-stroked-button matTooltip="{{'partner-manager.create-software-dialog.tooltip-1'|translate}}"
              (click)="addOption(propName.value, propType.value, propValue.value)">
        <mat-icon>add_circle</mat-icon></button>
      <mat-list>
        <mat-list-item *ngFor="let option of optionsList">
          <ng-container *ngIf="option.name!='symbols_to_watch_0645'">
            {{option.name}} : {{option.value}} {{
            'partner-manager.card-1.software-tootltip-value-2'|translate
            }} - {{options[option.type]}}
            <button mat-stroked-button style="margin-left: 30px" (click)="removeOption(option.name)">
              <mat-icon>delete</mat-icon></button>
          </ng-container>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </div>
    <button style="margin-top: 50px" mat-button (click)="onNoClick()" cdkFocusInitial>
      {{'partner-manager.create-software-dialog.action-close'|translate}}
    </button>
    <button [disabled]="!canAdd" style="margin-top: 50px; margin-left: 30px" mat-raised-button color="primary"
            [mat-dialog-close]="software" cdkFocusInitial>
      {{'partner-manager.create-software-dialog.action-add'|translate}}
    </button>
  </div>
</div>
